import { AvatarStage } from '../../avatar'
import { Dialogue } from './Dialogue'
import { SceneToast } from './SceneToast'
import { ScenePanelRouter } from './ScenePanelRouter'

export function SceneHero({
  layout,
  stage,
  voiceActive,
  toastMsg,
  prevText,
  activeWho,
  activeText,
  isUserTurn,
  uiAction,
  agentActivity,
  sceneProps,
}) {
  return (
    <section className="hero">
      <div className={`avatar-island layout-${layout}`} aria-hidden="false">
        <AvatarStage stage={stage} voiceActive={voiceActive} layout={layout} />
      </div>
      <SceneToast message={toastMsg} />
      <ScenePanelRouter sceneProps={sceneProps} />
      <Dialogue
        prevText={prevText}
        activeWho={activeWho}
        activeText={activeText}
        isUserTurn={isUserTurn}
        uiAction={uiAction}
        onUserChoice={sceneProps.onUserChoice}
        agentActivity={agentActivity}
      />
    </section>
  )
}
